export const CITIES: string[] = [
  'New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Philadelphia',
  'San Antonio', 'San Diego', 'Dallas', 'San Jose', 'Austin', 'Jacksonville',
  'Fort Worth', 'Columbus', 'Charlotte', 'San Francisco', 'Indianapolis', 'Seattle',
  'Denver', 'Washington DC', 'Boston', 'El Paso', 'Nashville', 'Detroit',
  'Oklahoma City', 'Portland', 'Las Vegas', 'Memphis', 'Louisville', 'Baltimore',
  'Milwaukee', 'Albuquerque', 'Tucson', 'Fresno', 'Sacramento', 'Mesa',
  'Kansas City', 'Atlanta', 'Long Beach', 'Colorado Springs', 'Raleigh', 'Miami',
  'Virginia Beach', 'Omaha', 'Oakland', 'Minneapolis', 'Tulsa', 'Arlington',
  'Tampa', 'New Orleans', 'Wichita', 'Cleveland', 'Bakersfield',
  // Canada
  'Toronto', 'Montreal', 'Vancouver', 'Calgary', 'Edmonton', 'Ottawa',
  'Winnipeg', 'Quebec City', 'Hamilton', 'Kitchener', 'Victoria', 'Halifax',
  'Oshawa',
  // Europe
  'London', 'Berlin', 'Madrid', 'Rome', 'Paris', 'Bucharest', 'Vienna',
  'Hamburg', 'Warsaw', 'Budapest', 'Barcelona', 'Munich', 'Milan', 'Prague',
  'Sofia', 'Brussels', 'Birmingham', 'Cologne', 'Naples', 'Turin', 'Valencia',
  'Marseille', 'Krakow', 'Amsterdam', 'Zagreb', 'Seville', 'Zaragoza', 'Athens',
  'Frankfurt', 'Palermo', 'Wroclaw', 'Rotterdam', 'Stuttgart', 'Dortmund', 'Essen',
  'Gothenburg', 'Malmo', 'Dublin', 'Copenhagen', 'Helsinki', 'Oslo', 'Stockholm',
  'Zurich', 'Geneva', 'Basel', 'Bern', 'Lisbon', 'Porto', 'Lyon', 'Toulouse',
  'Nice', 'Nantes', 'Strasbourg', 'Montpellier', 'Bordeaux', 'Lille', 'Rennes',
  'Reims', 'Le Havre',
  // Asia Pacific
  'Tokyo', 'Delhi', 'Shanghai', 'Dhaka', 'São Paulo', 'Cairo', 'Mexico City',
  'Beijing', 'Mumbai', 'Osaka', 'Karachi', 'Chongqing', 'Istanbul', 'Kolkata',
  'Manila', 'Lagos', 'Rio de Janeiro', 'Tianjin', 'Kinshasa', 'Guangzhou',
  'Moscow', 'Shenzhen', 'Lahore', 'Bangalore', 'Bogotá', 'Jakarta', 'Chennai',
  'Lima', 'Bangkok', 'Seoul', 'Nagoya', 'Hyderabad', 'Tehran', 'Chengdu',
  'Nanjing', 'Wuhan', 'Ho Chi Minh City', 'Luanda', 'Ahmedabad', 'Kuala Lumpur',
  'Xian', 'Hong Kong', 'Dongguan', 'Hangzhou', 'Foshan', 'Shenyang', 'Riyadh',
  'Baghdad', 'Santiago', 'Surat', 'Suzhou', 'Pune', 'Harbin', 'Dar es Salaam',
  'Belo Horizonte', 'Singapore', 'Fukuoka', 'Khartoum', 'Johannesburg',
  'Saint Petersburg', 'Qingdao', 'Dalian', 'Washington', 'Yangon', 'Alexandria',
  'Jinan', 'Guadalajara',
  // Australia & New Zealand
  'Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide', 'Gold Coast',
  'Newcastle', 'Canberra', 'Sunshine Coast', 'Wollongong', 'Hobart', 'Geelong',
  'Townsville', 'Cairns', 'Darwin', 'Toowoomba', 'Ballarat', 'Bendigo', 'Albury',
  'Launceston', 'Auckland', 'Wellington', 'Christchurch', 'Tauranga',
  'Napier-Hastings', 'Dunedin', 'Palmerston North', 'Nelson', 'Rotorua',
  // Major Indian cities
  'Jaipur', 'Lucknow', 'Kanpur', 'Nagpur', 'Indore', 'Thane', 'Bhopal',
  'Visakhapatnam', 'Patna', 'Vadodara', 'Ghaziabad', 'Ludhiana', 'Agra',
  'Nashik', 'Faridabad', 'Meerut', 'Rajkot', 'Kalyan-Dombivali', 'Vasai-Virar',
  'Varanasi', 'Srinagar', 'Aurangabad', 'Dhanbad', 'Amritsar', 'Navi Mumbai',
  'Allahabad', 'Ranchi', 'Howrah', 'Coimbatore', 'Jabalpur', 'Gwalior',
  'Vijayawada', 'Jodhpur', 'Madurai', 'Raipur', 'Kota', 'Guwahati', 'Chandigarh',
  'Solapur', 'Hubballi-Dharwad', 'Tiruchirappalli', 'Bareilly', 'Mysore',
  'Tiruppur', 'Gurgaon', 'Aligarh', 'Jalandhar', 'Bhubaneswar', 'Salem',
  'Warangal', 'Guntur', 'Bhiwandi', 'Saharanpur', 'Gorakhpur', 'Bikaner',
  'Amravati', 'Noida', 'Jamshedpur', 'Bhilai', 'Cuttack', 'Firozabad', 'Kochi',
  'Nellore', 'Bhavnagar', 'Dehradun', 'Durgapur', 'Asansol', 'Rourkela',
  'Nanded', 'Kolhapur', 'Ajmer', 'Akola', 'Gulbarga', 'Jamnagar', 'Ujjain',
  'Loni', 'Siliguri', 'Jhansi', 'Ulhasnagar', 'Jammu', 'Mangalore', 'Erode',
  'Belgaum', 'Ambattur', 'Tirunelveli', 'Malegaon', 'Gaya', 'Jalgaon', 'Udaipur',
  'Maheshtala', 'Sangli-Miraj & Kupwad',
].filter((v, i, a) => a.indexOf(v) === i).sort();
